import LocalStorageUtil from "@/utils/store";
import { create } from "zustand";
import { persist } from "zustand/middleware";

type UserStore = {
    userInfo: UserInfo | null,
    isDark: boolean,
    themeMode: "light" | "retro" | "dark",
    authCode: string,
    aiWords: string[],
    administrator: string[],
    isMP: boolean,
    /**
     * 设置聊天存储状态中的特定键的值。
     * 
     * @param key - 要更新的状态属性的键。
     * @param cb - 一个回调函数，接受键的当前值并返回新值。
     */
    setData: <K extends keyof UserStore>(key: K, cb: (data: UserStore[K]) => UserStore[K]) => void
}

export const useUserStore = create<UserStore>()(
    persist(
        (set) => ({
            userInfo: null,
            aiWords: LocalStorageUtil.getItem('aiWords') || [],
            isMP: false,
            administrator: [
                '18935962250',
                '13121132123'
            ],
            authCode: (() => {
                return localStorage.authCode || '';
            })(),
            themeMode: (() => {
                if (typeof localStorage === 'undefined') return 'light';
                const t = localStorage.theme;
                if (t === 'dark' || t === 'retro' || t === 'light') return t;
                return 'light';
            })(),
            isDark: (() => {
                const t = localStorage.theme;
                return t === 'dark';
            })(),
            setData: <K extends keyof UserStore>(key: K, cb: (data: UserStore[K]) => UserStore[K]) => {
                set((state) => ({
                    [key]: cb(state[key])
                }))
            },
        }),
        {
            name: "chat-store",
            // 避免持久化的 isDark/themeMode 覆盖“默认白灰”逻辑
            partialize: (state) => ({
                userInfo: state.userInfo,
                aiWords: state.aiWords,
                isMP: state.isMP,
                administrator: state.administrator,
                authCode: state.authCode,
            }),
        }
    )
);